import { IProduct, IVariant } from "redux/reducers/models/product";
import { TeesheetBookingFee } from "api/rpc/2024-04/facilityAdmin/teesheet/bookingFee";

export type TBookingFeeFormValues = {
  product: IProduct | null;
  variant: IVariant | null;
  days_in_advance_start: string;
  days_in_advance_end: string;
  non_refundable: boolean;
  customerTypeIds: number[];
};

export const initialBookingFeeFormValues: TBookingFeeFormValues = {
  product: null,
  variant: null,
  days_in_advance_start: "",
  days_in_advance_end: "",
  non_refundable: false,
  customerTypeIds: [],
};

export function isBookingFeeFormValid(values: TBookingFeeFormValues): boolean {
  return (
    !!values.variant?.id &&
    (values.days_in_advance_start ?? "") !== "" &&
    (values.days_in_advance_end ?? "") !== "" &&
    (values.customerTypeIds?.length ?? 0) > 0
  );
}

export function bookingFeeToFormValues(fee: TeesheetBookingFee): TBookingFeeFormValues {
  return {
    product: fee.product ?? null,
    variant: fee.variant ?? null,
    days_in_advance_start: fee.days_in_advance_start?.toString() ?? "",
    days_in_advance_end: fee.days_in_advance_end?.toString() ?? "",
    non_refundable: fee.non_refundable ?? false,
    customerTypeIds: fee.customer_types?.map(type => type?.id).filter((id): id is number => id != null) ?? [],
  };
}

export function applyFormValuesToBookingFee(
  fee: TeesheetBookingFee,
  values: TBookingFeeFormValues,
): TeesheetBookingFee {
  return {
    ...fee,
    product: values.product ?? undefined,
    variant: values.variant ?? undefined,
    days_in_advance_start: values.days_in_advance_start ?? "",
    days_in_advance_end: values.days_in_advance_end ?? "",
    non_refundable: values.non_refundable ?? false,
  };
}
